export default __webpack_public_path__ + "static/media/partners6.d33cd886.png";